import { render, staticRenderFns } from "./calcSD2-1.vue?vue&type=template&id=2e5feda4&scoped=true"
import script from "./calcSD2-1.vue?vue&type=script&lang=js"
export * from "./calcSD2-1.vue?vue&type=script&lang=js"
import style0 from "./calcSD2-1.vue?vue&type=style&index=0&id=2e5feda4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5feda4",
  null
  
)

export default component.exports